import NewspaperNewspaperStatus from './NewspaperNewspaperStatus'

export default NewspaperNewspaperStatus
